export const Logo = ({ dark = false, className = "" }) => (
  <a
    href="#top"
    data-testid="logo-link"
    className={`flex items-center ${className}`}
    aria-label="Luiza Wójtowicz-Waga – strona główna"
  >
    <img
      src="/logo-luiza.png"
      alt="Luiza Wójtowicz-Waga"
      width="847"
      height="344"
      className={`h-14 w-auto sm:h-16 ${dark ? "brightness-0 invert" : ""}`}
    />
  </a>
);
